import React from "react";
import bgImage1 from "../Images/45f4e8b4fd6291eb770a1fea8adaf3de5df72eae.jpg";
import "../NagthaneComponent/NagthaneCss/NagathaneHero.css";

export default function NagathaneHero() {
  return (
    <div
      className="nagathane-hero-section"
      style={{ backgroundImage: `url(${bgImage1})` }}
    >
      <div className="nagathane-hero-overlay"></div>
      <div className="nagathane-hero-content">
        <h1>आमचे नागठाणे</h1>
        <p>
          सातत्याने विकासाच्या दिशेने वाटचाल करणारे नागठाणे. आज ग्रामीण विकास,
          शिक्षण, शेती, आरोग्य आणि सामाजिक एकतेचा उत्तम आदर्श ठरत आहे.
        </p>
        <p className="code">गावाचा LGD Code- 190290</p>
      </div>
    </div>
  );
}
